module.exports = __webpack_public_path__ + "static/social-ffa87d40c329f02d6adac4c09e15ed01.png";